<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-dialog v-model="Mostrar" :width="width" persistent :fullscreen="fullscreen" :hide-overlay="overlay">
      <vue-draggable-resizable :draggable="dragable"  :drag-handle="'.headline'"
                               :resizable="false" :parent="false" :style="'border: none;width:' +  width">
        <v-card width="100%" >
          <v-card-title class="headline popup-header" primary-title id="modalhead"
                        style="background: black; color: white; padding: 0px 20px 0px 20px">
            {{getTitulo()}}
            <v-spacer></v-spacer>
            <v-tooltip left  v-if="dragable">
              <template v-slot:activator="{ on }">
                <v-checkbox small class="inp"  dark v-on="on" color="prmary" v-model="overlay" label=""></v-checkbox>
              </template>
              <span>Habilitar fundo</span>
            </v-tooltip>

          </v-card-title>
          <v-card-text>
            <slot></slot>
          </v-card-text>
        </v-card>
      </vue-draggable-resizable>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
  import util from '../assets/js/Util'

  export default {
    props: {
      titulo: {
        default: ''
      },
      modal: {
        default: false
      },
      fullscreen: {
        default: false
      },
      dragable: {
        default: false
      },
      width: {
        default: '40%'
      }
    },
    name: "ModalCadastroSmall",

    data() {
      return {
        overlay: false,
        margem_left: '25',
        classe: '',
        util
      }
    },
    methods: {
      getTitulo() {
        if (util.validaCampo(this.titulo)) {
          return this.titulo
        } else {
          return this.$router.currentRoute.meta
        }
      },
    },
    computed: {
      Mostrar: {
        get() {
          return this.modal
        },
        set() {
          return this.Mostrar
        }
      },
    },
    watch: {
      modal: function () {
        if (this.modal) {
          var _this = this;
          var inter = setInterval(function () {
            var mywidth = document.getElementById('drg');
            if (mywidth !== null) {
              var width = window.screen.width;
              var w = mywidth.clientWidth;
              var res = width - w;
              res = res / 2;
              res = (res * 100) / width;
              _this.margem_left = parseInt(res)
            }
            clearInterval(inter)
          }, 500)
        }
      }
    }
  }
</script>

<style scoped>
  .headline:hover{
    cursor: grab;
  }
</style>
